document.addEventListener('DOMContentLoaded', function () {
    const ACTION_EVENTS = ['click', 'keydown'];
    const productStickyAddToCart = document.querySelector('custom-product-sticky-add-to-cart');
    let productRender = productStickyAddToCart.querySelector('product-rerender');
    const observeFormId = productRender.getAttribute('observe-form');

    const stickySelectSizeFunction = () => {
        productRender = productStickyAddToCart.querySelector('product-rerender');
        const variantStickyButton = productStickyAddToCart.querySelector('.product-sticky-add-to-cart-toggle-variants');
        const variantModalTarget = productStickyAddToCart.querySelector(`[id="${variantStickyButton.getAttribute('aria-controls')}"]`);

        ACTION_EVENTS.forEach(function (eventType) {
            variantStickyButton.addEventListener(eventType, function (event) {
                if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }
                event.preventDefault();
                const expanded = variantStickyButton.getAttribute('aria-expanded') === 'true' || false;
                variantStickyButton.setAttribute('aria-expanded', !expanded);
                variantModalTarget.classList.toggle('visible', !expanded);
                variantModalTarget.toggleAttribute('hidden', expanded);
            });
        });

        productRender.querySelectorAll('label[for*="-sticky-add-to-cart-"]').forEach((label) => {
            ACTION_EVENTS.forEach(function (eventType) {
                label.addEventListener(eventType, function (event) {
                    if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                        return;
                    }
                    event.preventDefault();
                    const inputId = label.getAttribute('for');
                    const inputElement = document.getElementById(inputId.split('-sticky-add-to-cart').join(''));
                    inputElement?.click();
                });
            });
        });

        const sizeVariant = document.querySelector('[data-size="true"]');
        const sizeElement = sizeVariant.querySelector('[checked="checked"] + label');
        if (sizeElement) {
            document.querySelectorAll('[data-update-text]').forEach((el) => {
                el.textContent = sizeElement.textContent.trim();
            });
        }
    };

    stickySelectSizeFunction();

    document.forms[observeFormId].addEventListener('variant:change', (event) => {
        stickySelectSizeFunction();
    });


    ACTION_EVENTS.forEach(function (eventType) {
        document.body?.addEventListener(eventType, function (event) {
            if (event.target?.matches('[data-size="true"] .variant-picker__option-info button') || event.target?.closest('[data-size="true"] .variant-picker__option-info button')) {
                if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }
                event.preventDefault();
                const inputId = event.target.getAttribute('aria-controls');
                const inputElement = document.getElementById(inputId);
                inputElement?.open();
            }
        });
    });
});
